

import Dashboard from "carrental/views/pages/Dashboard.js";
import Login from "carrental/views/pages/Login.js";
import Notifications from "views/components/Notifications.js";
//import UserProfile from "views/pages/UserProfile.js";
import Tenant from "carrental/views/pages/Tenant.js";
import CityArea from "carrental/views/pages/CityArea.js";
import Vtype from "carrental/views/pages/Vtype.js";
import Btype from "carrental/views/pages/Btype.js";
import Currency from "carrental/views/pages/Currency.js";
import Banners from "carrental/views/pages/Banners.js";
import Listing from "carrental/views/pages/Listing.js";
import Brand from "carrental/views/pages/Brand.js";
import Vehicle from "carrental/views/pages/Vehicle.js";

import Features from "carrental/views/pages/Features.js";
import Users from 'carrental/views/pages/Users.js'
import Tenreqs from 'carrental/views/pages/Tenreqs'
import ListingApproval from 'carrental/views/pages/ListingApproval'
import Lapprove from 'carrental/views/pages/Lapprove'
import Logs from 'carrental/views/pages/Logs'
const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Tenants",
    icon: "nc-icon nc-book-bookmark",
    state: "adminpanels",
    views: [
      {
        path: "/tanent",
        name: "Tanents",
        mini: "TT",
        component: Tenant,
        layout: "/admin",
      },
      {
        path: "/listings",
        name: "Listings",
        mini: "LL",
        component: Listing,
        layout: "/admin",
      },
      {
        path: "/liap",
        name: "Awaiting",
        mini: "LP",
        component: Lapprove,
        layout: "/admin",
      },
      {
        path: "/tenreqs",
        name: "Requests",
        mini: "LR",
        component: Tenreqs,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "System Tasks",
    icon: "nc-icon nc-book-bookmark",
    state: "adminpanel",
    views: [
     
      {
        path: "/cityarea",
        name: "cityarea",
        mini: "CAA",
        component: CityArea,
        layout: "/admin",
      },
     
      {
        path: "/banners",
        name: "banners",
        mini: "CAA",
        component: Banners,
        layout: "/admin",
      },
      {
        path: "/fcr",
        name: "Currency Register",
        mini: "CRR",
        component: Currency,
        layout: "/admin",
      },
     
     
    ],
  },
  {
    collapse: true,
    name: "Vehicle Tasks",
    icon: "nc-icon nc-book-bookmark",
    state: "adminpanel1",
    views: [
     
      {
        path: "/brand",
        name: "brand",
        mini: "BFF",
        component: Brand,
        layout: "/admin",
      },
      {
        path: "/vtype",
        name: "type",
        mini: "TEF",
        component: Vtype,
        layout: "/admin",
      },
      {
        path: "/btype",
        name: "Body",
        mini: "BEF",
        component: Btype,
        layout: "/admin",
      },
      {
        path: "/features",
        name: "features",
        mini: "FEF",
        component: Features,
        layout: "/admin",
      },
      {
        path: "/model",
        name: "Model",
        mini: "VFF",
        component: Vehicle,
        layout: "/admin",
      },
    ]
  },
  {
    collapse: true,
    name: "Users",
    icon: "nc-icon nc-book-bookmark",
    state: "adminpanel3",
    views: [
      {
        path: "/users",
        name: "Users",
        mini: "UFF",
        component: Users,
        layout: "/admin",
      },
     
    ]
  },
 
  {
    path: "/login",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/lapprove/:tuid",
    component: ListingApproval,
    layout: "/admin",
  },
  {
    path: "/getlogs",
    component: Logs,
    layout: "/admin",
  }
];

export default routes;
/** 
 * 
 * {
    collapse: true,
    name: "Sample",
    icon: "nc-icon nc-book-bookmark",
    state: "adminpanel2",
    views: [
      {
        path: "/regular-forms",
        name: "Regular Forms",
        mini: "RF",
        component: RegularForms,
        layout: "/admin",
      },
      {
        path: "/extended-forms",
        name: "Extended Forms",
        mini: "EF",
        component: ExtendedForms,
        layout: "/admin",
      },
      {
        path: "/validation-forms",
        name: "Validation Forms",
        mini: "VF",
        component: ValidationForms,
        layout: "/admin",
      },
      {
        path: "/sweet-alert",
        name: "Sweet Alert",
        mini: "SA",
        component: SweetAlert,
        layout: "/admin",
      },
    ]
  },

{
  collapse: true,
  name: "Pages",
  icon: "nc-icon nc-book-bookmark",
  state: "pagesCollapse",
  views: [
    {
      path: "/timeline",
      name: "Timeline",
      mini: "T",
      component: Timeline,
      layout: "/admin",
    },
    {
      path: "/login",
      name: "Login",
      mini: "L",
      component: Login,
      layout: "/auth",
    },
    {
      path: "/register",
      name: "Register",
      mini: "R",
      component: Register,
      layout: "/auth",
    },
    {
      path: "/lock-screen",
      name: "LockScreen",
      mini: "LS",
      component: LockScreen,
      layout: "/auth",
    },
    {
      path: "/user-profile",
      name: "UserProfile",
      mini: "UP",
      component: UserProfile,
      layout: "/admin",
    },
  ],
},
{
  collapse: true,
  name: "Components",
  icon: "nc-icon nc-layout-11",
  state: "componentsCollapse",
  views: [
    {
      path: "/buttons",
      name: "Buttons",
      mini: "B",
      component: Buttons,
      layout: "/admin",
    },
    {
      path: "/grid-system",
      name: "Grid System",
      mini: "GS",
      component: GridSystem,
      layout: "/admin",
    },
    {
      path: "/panels",
      name: "Panels",
      mini: "P",
      component: Panels,
      layout: "/admin",
    },
    {
      path: "/sweet-alert",
      name: "Sweet Alert",
      mini: "SA",
      component: SweetAlert,
      layout: "/admin",
    },
    {
      path: "/notifications",
      name: "Notifications",
      mini: "N",
      component: Notifications,
      layout: "/admin",
    },
    {
      path: "/icons",
      name: "Icons",
      mini: "I",
      component: Icons,
      layout: "/admin",
    },
    {
      path: "/typography",
      name: "Typography",
      mini: "T",
      component: Typography,
      layout: "/admin",
    },
  ],
},
{
  collapse: true,
  name: "Forms",
  icon: "nc-icon nc-ruler-pencil",
  state: "formsCollapse",
  views: [
    {
      path: "/regular-forms",
      name: "Regular Forms",
      mini: "RF",
      component: RegularForms,
      layout: "/admin",
    },
    {
      path: "/extended-forms",
      name: "Extended Forms",
      mini: "EF",
      component: ExtendedForms,
      layout: "/admin",
    },
    {
      path: "/validation-forms",
      name: "Validation Forms",
      mini: "VF",
      component: ValidationForms,
      layout: "/admin",
    },
    {
      path: "/wizard",
      name: "Wizard",
      mini: "W",
      component: Wizard,
      layout: "/admin",
    },
  ],
},
{
  collapse: true,
  name: "Tables",
  icon: "nc-icon nc-single-copy-04",
  state: "tablesCollapse",
  views: [
    {
      path: "/regular-tables",
      name: "Regular Tables",
      mini: "RT",
      component: RegularTables,
      layout: "/admin",
    },
    {
      path: "/extended-tables",
      name: "Extended Tables",
      mini: "ET",
      component: ExtendedTables,
      layout: "/admin",
    },
    {
      path: "/react-tables",
      name: "React Tables",
      mini: "RT",
      component: ReactTables,
      layout: "/admin",
    },
  ],
},
{
  collapse: true,
  name: "Maps",
  icon: "nc-icon nc-pin-3",
  state: "mapsCollapse",
  views: [
    {
      path: "/google-maps",
      name: "Google Maps",
      mini: "GM",
      component: GoogleMaps,
      layout: "/admin",
    },
    {
      path: "/full-screen-map",
      name: "Full Screen Map",
      mini: "FSM",
      component: FullScreenMap,
      layout: "/admin",
    },
    {
      path: "/vector-map",
      name: "Vector Map",
      mini: "VM",
      component: VectorMap,
      layout: "/admin",
    },
  ],
},
{
  path: "/widgets",
  name: "Widgets",
  icon: "nc-icon nc-box",
  component: Widgets,
  layout: "/admin",
},
{
  path: "/charts",
  name: "Charts",
  icon: "nc-icon nc-chart-bar-32",
  component: Charts,
  layout: "/admin",
},
{
  path: "/calendar",
  name: "Calendar",
  icon: "nc-icon nc-calendar-60",
  component: Calendar,
  layout: "/admin",
},

*/